export default __webpack_public_path__ + "static/media/black-rook.6bcce16d.png";